
import { mapState, mapGetters } from 'vuex'
import promotions from '~/mixins/common/pages/promotions'
export default {
    mixins: [promotions],
    computed: {
        ...mapState({
            loadingPromotion: (state) => state.themes.promotion.loading,
        }),
        ...mapGetters({
            promotions: 'themes/promotion/availablePromotions',
        }),
    },
    async mounted() {
        if (this.promotions.length === 0) {
            await this.$store.dispatch(
                'themes/promotion/getAvailablePromotions'
            )
        }
    },
}
